import { useState, useEffect } from 'react';

const usePaginatedData = (initialPageNo = 1, initialRecords = 50, filterFunction, filterObject) => {
    const [filterData, setFilterData] = useState([]);
    const [totalRecord, setTotalRecord] = useState([]);
    const [pageNo, setPageNo] = useState(initialPageNo);
    const [records, setRecords] = useState(initialRecords);
    const [nextIsValid, setNextIsValid] = useState(false);
    const [prevIsValid, setPrevIsValid] = useState(false);   
    const [loader, setLoader] = useState(false);
    useEffect(() => {
        loadInitialData();
    }, []);

    const loadInitialData = () => {
        if (filterObject) {
            // setLoader(true);
            fetchData(filterObject);
        } else {
            fetchData({});
        }
    };

    const fetchData = async (filterObj = {}) => {
        setLoader(true);
        const params = { p: pageNo, records, ...filterObj };
        setPageNo(params.p);
        filterFunction(params).then((res) => {
            setFilterData(res?.data?.filteredData);
            setTotalRecord(res?.data?.totalRecords);
            setNextIsValid(res?.data?.isNext ?? false)
            setPrevIsValid(res?.data?.isPrevious ?? false)
            setLoader(false);
        }).catch(err => {
            console.log("error: ", err);
            setLoader(false);
        });
    };

    const pageChangeHandler = (localPageNo) => {
        if (((pageNo < localPageNo)) || ((pageNo > localPageNo))) {
            fetchData({ ...filterObject, p: localPageNo });
        }
    };

    const recordChangeHandler = (recordSize) => {
        setRecords(recordSize);
        setPageNo(1);
        fetchData({ ...filterObject, p: 1, records: recordSize });
    };

    return {
        filterData,
        pageNo,
        records,
        totalRecord,
        nextIsValid,
        prevIsValid,
        pageChangeHandler,
        recordChangeHandler,
        fetchData,
        loader,
    };
};

export default usePaginatedData;